import { all, call, put, takeEvery } from 'redux-saga/effects';
import actions from './actions';
import { getRequest } from '../../../../helpers/axiosClient';

export function* getMyProductdetails(params) {

    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.MYPRODUCT_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.MYPRODUCT_DETAILS_FAILURE });
        return error;
    }
}

export function* getProductPrice(params) {
    try {
        let response = yield call(() => getRequest(`${params.url}`));
        yield put({
            type: actions.PRODUCT_PRICE_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.PRODUCT_PRICE_FAILURE });
        return error;
    }
}

export function* clearProductPrice() {
    yield put({ type: actions.CLEAR_PRICE_SUCCESS });
}

export default function* productProductSaga() {
    yield all([
        takeEvery(actions.MYPRODUCT_DETAILS_START, getMyProductdetails),      
        takeEvery(actions.PRODUCT_PRICE_START, getProductPrice),
        takeEvery(actions.CLEAR_PRICE_START, clearProductPrice),
    ])
}